import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'

import { Payment } from '@/@types/payment'
import { Svg } from '@/components'
import { ColumnHeader } from '@/components/data-table/column-header'

export const TABLE_COLUMNS: ColumnDef<Payment>[] = [
  {
    id: 'user.name',
    accessorKey: 'user.name',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Nome do cliente" />
    ),
    cell: ({ row }) => (
      <div className="flex gap-2 items-center">
        <Svg src="/icons/payments_logs.svg" className="max-w-6" />
        <span>{row.original.user.name ?? '-'}</span>
      </div>
    ),
    filterFn: (row, id, value) => {
      const cellValue = String(row.getValue(id))
      return cellValue.toLowerCase().includes(String(value).toLowerCase())
    },
  },
  {
    id: 'user.level',
    accessorKey: 'user.level',
    header: 'Nível',
    cell: ({ row }) => String(row.original.user.level),
  },
  {
    id: 'phoneNumber',
    accessorKey: 'phoneNumber',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Número de telefone" />
    ),
  },
  {
    id: 'amount',
    accessorKey: 'amount',
    header: ({ column }) => (
      <ColumnHeader column={column} title="Montante (MZN)" />
    ),
  },
  {
    id: 'createdAt',
    accessorKey: 'createdAt',
    header: () => 'Data',
    cell: ({ row }) => format(row.original.createdAt, 'dd/MM/yyyy'),
  },
  {
    id: 'createdAtTime',
    accessorKey: 'createdAtTime',
    header: () => 'Hora',
    cell: ({ row }) => format(row.original.createdAt, 'HH:mm'),
  },
]
